<template lang="pug">
    .products-template
        .products-template-title
            p   {{ lenguageSelected.content1 }}
        .products-template-content
            .products-template-content-description
                ul(style="padding-left: 15px;")
                    li(v-for="item in lenguageSelected.content2")  {{ item.title }}
                        ul
                            li {{ item.content }}
                
                p {{ lenguageSelected.content3 }}
</template>


<script>
export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            lenguage: 'ES',
            lenguageEN: {
                content1: 'Site Management',
                content2: [
                    {title: 'Property Owners, Buildings and Rooftops', content: 'We offer a suite of solutions to landlords seeking to create revenue generation opportunities from underutilized portions of their properties and developments.'},
                    {title: 'City Infrastructure Owners', content: 'ATP’s real estate team helps urban utility owners market their property to carriers by managing the leasing process from start to finish. Our deals help generate additional revenue from your assets by hosting network operator equipment.' },
                    
                ],
                content3: 'For more information on how to earn additional revenue from your property, click the “Contact Us” button to your left.'
            },

            lenguageES: {
                content1: 'Site Management',
                content2: [
                    {title: 'Propietarios de edificios, azoteas y espacios', content: 'Ofrecemos un conjunto de soluciones para los propietarios que buscan crear oportunidades de generación de ingresos adicionales en áreas subutilizadas de sus propiedades.'},
                    {title: 'Propietarios de infraestructura urbana', content: 'El equipo de bienes raíces de ATP ayuda a los propietarios de servicios públicos e infraestructura urbana a comercializar sus propiedades y espacios con operadores de telecomunicaciones. Nuestros servicios les permiten generar ingresos adicionales en sus activos.' },
                    
                ],
                content3: 'Para obtener más información sobre cómo obtener ingresos adicionales en sus inmuebles, seleccione el boton de la izquierda para ir a la sección de contacto.'
            }
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/molecules/PmWeManage.vue